// TODO(temp): Debug helper — clears local state, then either exits back to
// the host app (when embedded in a WebView) or reloads (plain dev tab).
// Remove this component, its import in main.tsx, and the file itself once no
// longer needed.
import { debugGameExit, isEmbeddedHost } from '@/lib/game-exit';
import { useTranslation } from 'react-i18next';

interface DebugClearStorageButtonProps {
  readonly className?: string;
}

export function DebugClearStorageButton({
  className = '',
}: DebugClearStorageButtonProps) {
  const { t } = useTranslation();
  const placementStyle = className
    ? {}
    : {
        position: 'absolute' as const,
        top: '14px',
        right: 0,
        width: 'auto',
      };

  const handleClick = () => {
    try {
      window.localStorage.clear();
    } catch {
      /* storage may be unavailable in private mode */
    }
    if (isEmbeddedHost()) {
      debugGameExit();
    } else {
      window.location.reload();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Clear local storage and reload"
      title="Clear localStorage and reload"
      className={className}
      style={{
        ...placementStyle,
        zIndex: 99999,
        cursor: 'pointer',
        backgroundColor: '#ffffff2e',
        border: '1px solid #ffffff96',
        padding: '7px 20px',
        borderRadius: '9999px',
        fontSize: '14px',
        color: '#ffffff',
      }}
    >
      {t('common.exitGame')}
    </button>
  );
}
